import React from 'react';
import PhonicsLt from './phonics/PhonicsLt';
import { letterDataLt21 } from './phonics/phonics_data_lt21';

function PhonicsLt21() {
  return <PhonicsLt letterData={letterDataLt21} />;
}

export default PhonicsLt21;
